<template>
    <footer class="foot">
        <div class="col-2 font-14">
            <div class="left content flex-row">
                <img :src="'/logo.png'|imgUrl" alt="logo">
                <div class="foot-btn"><span :class="{'theme':fna=='product'}" @click="$push('/product')">产品方案</span> ·
                    <span :class="{'theme':fna=='solution'}" @click="$push('/dynamic/solution')">解决方案</span> ·
                    <span :class="{'theme':fna=='advisory'}" @click="$push('/dynamic/advisory')">行业资讯</span> ·
                    <span :class="{'theme':fna=='problem'||fna=='manual'}" @click="$push('/help/problem')">帮助中心</span> ·
                    <span :class="{'theme':fna=='Introduction'}" @click="$push('/about/Introduction')">关于我们</span> ·
                    <span :class="{'theme':fna=='join'}" @click="$push('/about/join')">加入我们</span>
                </div>
                <div class="flex-row">
                    <i class="iconfont iconlocation"></i>
                    中山市东区起湾道紫马奔腾6座7楼b
                    <i class="iconfont icondianhua2 m-l-30"></i>13025550787 <i class="iconfont iconyouxiang m-l-30"></i>741753715@qq.com</div>
                <div>
                    Copyright @2018-2021 Huwa.All Rights Reserved.&nbsp;中山市虎蛙信息科技有限公司&nbsp;&nbsp;版权所有&nbsp;
                    <span class="onclick" @click="onClick">粤ICP备20004233号</span>
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44200002444958" class="police"><img :src="'/police.png'|imgUrl" width="20" height="20" style="float:left;width:20px;height:20px;"/><p style="float:left;height:20px;line-height:20px;">粤公网安备 44200002444958号</p></a>
                </div>
                <!-- <div style="width:300px;margin:0 auto; padding:20px 0;">
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44200002444958" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img :src="'/police.png'|imgUrl" width="20" height="20" style="float:left;width:20px;height:20px;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44200002444958号</p></a>
                </div> -->
                
            </div>
            <div class="right flex-row">
                <img class="er" :src="'/footer.png'|imgUrl" alt="">
                <div class="m-l-15 content">
                    <div>官方公众号</div>
                    <div>
                        微信扫一扫<br>
                        关注蓝领送工SaaS<br>
                        <el-button class="flex-center" size="mini" icon="el-icon-back">扫这里</el-button>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
        
        };
    },
    computed: {
        ...mapState({
            fna:state => state.routerName,
        })
    },
    methods: {
        onClick() {
            window.open('https://beian.miit.gov.cn/#/Integrated/recordQuery')
        }
    },
}
</script>

<style lang="less" scoped>
    .foot{border-top:1px solid #F0F0F0;border-top:1px solid var(--border);
        .col-2{max-width: 1200px;margin:auto;height: 200px;}
        .left{color: #999;color: var(--textPri);line-height:16px;height: 106px;flex-direction: column;align-items:flex-start;justify-content: space-between;
            .theme{color:#4d7fff;color:var(--theme);}
            .foot-btn span{cursor: pointer;
                &:hover{
                    color:#4d7fff;color:var(--theme);
                }
            }
            img{width: 136px;height: 24px;margin-bottom: 5px;}
            i{font-size: 16px;margin-right:4px;}
        }
        .right{
            .er{width:100px;height: 100px;border:3px solid #8fa0cc;border-radius: 4px;}
            /deep/.el-button{padding: 4px 15px 4px 6px;border-radius: 20px;background: linear-gradient(#4d7fff,#2f6aff);background: linear-gradient(var(--theme),var(--linear));color:#fff;margin-top:5px;border-width:0;
                span{font-size: 14px;}
                .el-icon-back{font-size: 18px;}
            }
        }
        .onclick{cursor: pointer;
            &:hover{color:#4d7fff;color:var(--theme);}
        }
        .police {
            display: inline-block;
            vertical-align: sub;
            text-decoration:none;
            height: 20px;
            line-height: 20px;
            margin: 0 0 0 5px;
            p { color:#939393; }
            &:hover p {
                color:#4d7fff;
                color:var(--theme);
            }
        }
    }

</style>

